import type { InjectionKey } from "vue";
import { inject, provide } from "vue";
import type { ModalStackApi } from "./modalStack.types";

export const MODAL_STACK_KEY: InjectionKey<ModalStackApi> =
  Symbol("modal-stack");

/**
 * Called by CModalStack to expose its navigation API to descendants.
 */
export const provideModalStack = (api: ModalStackApi): void => {
  provide(MODAL_STACK_KEY, api);
};

/**
 * Drive the enclosing CModalStack from any descendant (a trigger button, a
 * sheet header, etc.). Returns { push, back, close, canBack, activeName }.
 * Slot content can also receive the same methods as slot props on CModalSheet.
 */
export const useModalStack = (): ModalStackApi => {
  const api = inject(MODAL_STACK_KEY, null);

  if (!api) {
    throw new Error("useModalStack() must be used inside a <c-modal-stack>.");
  }

  return api;
};
